import React from "react";
import { Link, useHistory } from "react-router-dom";
import BrandLogo from "../../../components/BrandLogo/BrandLogo";
import "../../pages/Login Page/dealers-login.css";

function AuthShell({
  children,
  visualImage,
  visualKicker = "AutoTrade Port · Dealers",
  visualTitle,
  visualTitleAccent,
  visualPoints = [],
  activeCta = "signup",
}) {
  const history = useHistory();
  const year = new Date().getFullYear();

  return (
    <div className="dl-page">
      <div className="dl-fx" aria-hidden="true">
        <span className="dl-fx__orb dl-fx__orb--a" />
        <span className="dl-fx__orb dl-fx__orb--b" />
        <span className="dl-fx__orb dl-fx__orb--c" />
        <span className="dl-fx__beam" />
        <span className="dl-fx__grid" />
        <span className="dl-fx__scan" />
        <span className="dl-fx__grain" />
      </div>

      <header className="dl-top">
        <div className="dl-top__inner">
          <div className="dl-top__brand">
            <BrandLogo
              variant="light"
              compact
              onClick={() => history.push("/dealers")}
            />
            <span className="dl-badge dl-badge--on-dark">Dealers</span>
          </div>
          <nav className="dl-top__nav" aria-label="Auth shortcuts">
            <Link to="/">Home</Link>
            <Link to="/dealers">Trade floor</Link>
            <Link to="/dealers/dashbord/auction">Auctions</Link>
            <Link to="/dealers/dashbord/buynow">Buy now</Link>
            <Link to="/login" className="dl-top__cta">
              Log in
            </Link>
          </nav>
        </div>
      </header>

      <main className="dl-main">
        <div className={`dl-shell${visualImage ? "" : " dl-shell--solo"}`}>
          <section className="dl-panel dl-panel--form">{children}</section>

          {visualImage ? (
            <aside
              className="dl-panel dl-panel--visual"
              style={{ backgroundImage: `url(${visualImage})` }}
              aria-hidden="true"
            >
              <div className="dl-visual__shade" />
              <div className="dl-visual__content">
                <p className="dl-visual__kicker">{visualKicker}</p>
                <h2 className="dl-visual__title">
                  {visualTitle}
                  {visualTitleAccent ? <span>{visualTitleAccent}</span> : null}
                </h2>
                {visualPoints.length > 0 ? (
                  <ul className="dl-visual__points">
                    {visualPoints.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </aside>
          ) : null}
        </div>
      </main>

      <footer className="dl-bottom">
        <div className="dl-bottom__inner">
          <p className="dl-bottom__copy">© {year} AutoTrade Port · Dealers</p>
          <nav className="dl-bottom__links" aria-label="Legal">
            <Link to="/dealers/contactus">Contact</Link>
            <Link to="/dealers/faqs">FAQs</Link>
            <Link to="/dealers/privacypolicy">Privacy</Link>
            <Link to="/dealers/terms">Terms</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default AuthShell;
